import { useEffect, useState } from "react";
import { Swiper } from "swiper/types";
import {
    CardVariantsEnum,
    TransformedCardData,
} from "../../stories/Components/Card/interface";
import Card from "../../stories/Components/Card";
import { VIDEO_ASPECT_RATIOS } from "../VideoModal/constants";
import PlaylistCore from "../PlaylistCore";
import { PlaylistWidgetProps } from "./interface";
import { gqlMediaAspectRatios, placeholderItemCardProps } from "./constants";
import { fetchVideoByLineupFactory } from "../PlaylistCore/utils";

const PlaylistWidget = ({
    title,
    lineupSlug = "video-top-stories",
}: PlaylistWidgetProps) => {
    const [playingVideoIndex, setVideoPlayingIndex] = useState<number>(0);
    const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
    /* eslint-disable */
    const [playlistData, setPlaylistData] = useState<
        TransformedCardData[] | []
    >([]);
    /* eslint-enable */

    const onSlideChange = (swiper: Swiper) => {
        setVideoPlayingIndex(swiper.activeIndex); // eslint-disable-line
    };

    const handleClose = () => {
        setModalIsOpen(false);
    };

    const handleModalOpen = (index: number) => {
        return () => {
            setVideoPlayingIndex(index);
            setModalIsOpen(true);
        };
    };

    const PLACEHOLDER_CARDS = Array.from({ length: 5 }, (_, index) => (
        <Card
            {...placeholderItemCardProps}
            key={`playlist-widget-${title}-${index}`}
        />
    ));

    useEffect(() => {
        setPlaylistData([]);
        const fetchFn = fetchVideoByLineupFactory(lineupSlug, 20, [
            gqlMediaAspectRatios.ratio16By9,
        ]);
        fetchFn()
            .then((response: TransformedCardData[]) => {
                setPlaylistData(response);
            })
            .catch(() => {
                setPlaylistData([]);
            });
    }, [lineupSlug]);

    const cards = playlistData?.map(
        (item: TransformedCardData, index: number) => {
            const cardProps = {
                variant: CardVariantsEnum.MEDIA,
                key: `playlist-widget-${title}-${index}`,
                title: item.title,
                id: item.sourceId,
                url: item.url,
                renderAsButton: true,
                onClick: handleModalOpen(index),
                aspectRatio: 1.7778,
                showIcon: true,
                displayDuration: true,
                item: {
                    ...item,
                    image: {
                        ...item.image,
                        url: item.image?.aspects?.ratio16x9?.url || "",
                        loading: "lazy",
                    },
                },
            };
            return <Card {...cardProps} />;
        }
    );

    return (
        <PlaylistCore
            title={title}
            cardData={playlistData}
            playingVideoIndex={playingVideoIndex}
            modalIsOpen={modalIsOpen}
            onSlideChange={onSlideChange}
            handleClose={handleClose}
            aspectRatio={VIDEO_ASPECT_RATIOS["16x9"]}
            featureAttributionName="media-playlist-player"
            shouldDisableAds={false}
            autoplayNextOnVideoEnd={true}
        >
            {cards.length > 0 ? cards : PLACEHOLDER_CARDS}
        </PlaylistCore>
    );
};

export default PlaylistWidget;
